import React from "react";
import { Typography } from "@/components/Typography";

interface FileMetadataProps {
  size?: number;
}

const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const FileMetadata: React.FC<FileMetadataProps> = ({ size }) => {
  if (!size) return null;

  return (
    <Typography
      Tag="p"
      spacing={4}
      classname="body-s pdf-preview__metadata"
    >
      {formatBytes(size)}
    </Typography>
  );
};
